export default __webpack_public_path__ + "static/media/right-arrow.8bd9bcba.svg";